.root {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 100%;
    padding: 20px;
    gap: 20px;
}

.panel {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 20px;

    background: #333;
}

.description {
    text-align: center;
    font-style: italic;
    color: #888;
}

.score {
    font-size: 2em;
    text-align: center;
    font-variant-numeric: tabular-nums;
}

.upgrades {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

@keyframes upgradeButtonIn {
    0% {
        opacity: 0;
        margin-top: -83px;
    }
    50% {
        opacity: 0;
    }
    75% {
        margin-top: 0;
    }
    100% {
        opacity: 1;
    }
}

.upgradeButton {
    display: flex;
    flex-direction: column;
    padding: 5px;

    appearance: none;
    font: inherit;
    color: white;
    background: #444;
    border: 2px solid #444;
    cursor: pointer;

    &:hover {
        background: #555;
    }

    &:active {
        background: #444;
    }

    &:disabled {
        color: #888;
        background: transparent;
        cursor: default;
    }

    span {
        font-size: 0.8em;
    }

    & + button {
        animation: upgradeButtonIn .5s ease-out;
    }
}

.finalUpgradeButton {
    composes: upgradeButton;
}

.canvas {
    position: relative;
    align-self: center;
}

@keyframes canvasGameOverOverlayIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.canvasGameOverOverlay {
    position: absolute;
    inset: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: #333;
    font-size: 64px;
    font-weight: bold;

    animation: canvasGameOverOverlayIn ease-out 5s 5s;
    animation-fill-mode: both;

    button {
        padding: 5px 10px;

        appearance: none;
        background: #333;
        border: none;

        color: #ff0;
        font-family: inherit;
        font-weight: bold;

        cursor: pointer;

        &:hover {
            background: #444;
        }

        &:active {
            background: #333;
        }
    }
}
